// extracted by mini-css-extract-plugin
export default {"container":"actions_container__pzwmP","block":"actions_block__1DO9-"};